function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "109-map-location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.432,662.59,655.74,749.421a56.955,56.955,0,0,1-47.809,6.048L457,706.953a56.955,56.955,0,0,0-48.072,6.215l-110.5,70.537a25.806,25.806,0,0,1-38.6-14.736l-95.37-334.34a25.807,25.807,0,0,1,11.03-28.893l139.16-87.949a62.363,62.363,0,0,1,52.4-6.655L513.163,358.1a62.365,62.365,0,0,0,52.566-6.758l104.638-66.589a25.807,25.807,0,0,1,38.671,14.693L804.393,633.74A25.806,25.806,0,0,1,793.432,662.59Z",
    transform: "translate(0)",
    style: {
      fill: "#cccdcf",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.808,627.107,681.23,701.929a62.365,62.365,0,0,1-52.566,6.758L482.539,661.719a62.366,62.366,0,0,0-52.4,6.654L303.8,748.222a25.806,25.806,0,0,1-38.6-14.736l-95.369-334.34a25.806,25.806,0,0,1,11.029-28.893L320.013,282.3a62.365,62.365,0,0,1,52.4-6.654l146.124,46.969a62.362,62.362,0,0,0,52.566-6.759l104.638-66.588a25.807,25.807,0,0,1,38.671,14.693l95.355,334.292A25.807,25.807,0,0,1,798.808,627.107Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.513,623.926,446.65,562.24,343.331,597.611l-32.307-93.606-84.151,16.748,59,206.834a4.335,4.335,0,0,0,4.184,3.137,4.114,4.114,0,0,0,2.251-.681L412.422,654.13C411.9,653.519,468.513,623.926,468.513,623.926Z",
    transform: "translate(0)",
    style: {
      fill: "#eaf4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.808,627.107,681.23,701.929a62.365,62.365,0,0,1-52.566,6.758L482.539,661.719a62.366,62.366,0,0,0-52.4,6.654L303.8,748.222a25.806,25.806,0,0,1-38.6-14.736l-95.369-334.34a25.806,25.806,0,0,1,11.029-28.893L320.013,282.3a62.365,62.365,0,0,1,52.4-6.654l146.124,46.969a62.362,62.362,0,0,0,52.566-6.759l104.638-66.588a25.807,25.807,0,0,1,38.671,14.693l95.355,334.292A25.807,25.807,0,0,1,798.808,627.107Z",
    transform: "translate(0)",
    style: {
      fill: "none",
      stroke: "#363a5a",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.066,585.575s1.792-.467,4.812-1.349",
    transform: "translate(0)",
    style: {
      fill: "none",
      stroke: "#363a5a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.416,579.572c21.234-7.387,52.394-20.943,52.768-36.975.5-21.3-102.732-127.866-47.233-134.308,185.288-21.506,102.267,132.6,186.772,129.156,35.7-1.455-30.321-50.539,71.682-86.018,15.121-5.26,7.609-43.716,2.536-63.822",
    transform: "translate(0)",
    style: {
      fill: "none",
      stroke: "#363a5a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4,
      strokeDasharray: "10.176137924194336,15.264206886291504"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.979,380.226c-.844-3.017-1.4-4.8-1.4-4.8",
    transform: "translate(0)",
    style: {
      fill: "none",
      stroke: "#363a5a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.612,
    cy: 588.178,
    r: 48.192,
    style: {
      fill: "#3dc0cb",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.612,
    cy: 588.178,
    r: 27.946,
    style: {
      fill: "#3dc0cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.612,560.232a27.9,27.9,0,0,0-22.158,10.924,27.942,27.942,0,0,1,37.86,40.139,27.946,27.946,0,0,0-15.7-51.063Z",
    transform: "translate(0)",
    style: {
      fill: "#64c7cf"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.612,
    cy: 588.178,
    r: 27.946,
    style: {
      fill: "none",
      stroke: "#363a5a",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.347,338.84,446.5,354.033l-18.407-32.352-66.339-23.145a30.94,30.94,0,0,0-23.645,1.352L192.342,388.431a4.325,4.325,0,0,0-1.839,4.816l23.508,82.412L278.1,459.812,266.33,412.6Z",
    transform: "translate(0)",
    style: {
      fill: "#87d5f7",
      stroke: "#259ad6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "493.37 542.929 539.109 554.445 561.222 605.126 511.949 597.049 493.37 542.929",
    style: {
      fill: "#fddcbf",
      stroke: "#ecb072",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.426,391.11c-37.157,0-67.278-10.776-67.278-24.069s30.121-24.07,67.278-24.07,67.277,10.777,67.277,24.07S680.582,391.11,643.426,391.11Z",
    transform: "translate(0)",
    style: {
      fill: "#eaf4f7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.538 527.486 748.465 490.952 781.62 591.961 645.718 669.193 620.808 598.893 673.948 569.002 664.538 527.486",
    style: {
      fill: "#fddcbf",
      stroke: "#ecb072",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.481,249.681c0-57.8-46.914-104.344-103.761-101.642-50.9,2.42-94.292,45.782-94.292,98.124,0,75.717,99,134.1,99,134.1S742.481,321.88,742.481,249.681Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.585,350.964a44.189,44.189,0,0,1-54.6-.188c-29.3-23.2-71.677-65.323-71.677-114.86a96.3,96.3,0,0,1,19.808-58.17c-17.573,17.746-28.689,41.93-28.689,68.417,0,75.717,99,134.1,99,134.1s40.374-23.8,69.571-59.8A282.957,282.957,0,0,1,679.585,350.964Z",
    transform: "translate(0)",
    style: {
      fill: "#cd3c27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.72,148.039a97.984,97.984,0,0,0-49.9,16.723,96.75,96.75,0,0,1,37.234-9.485c56.847-2.7,103.762,43.841,103.762,101.642,0,56.61-60.894,104.724-87.192,122.863.515.314.8.484.8.484s99.055-58.386,99.055-130.585C742.481,191.881,695.567,145.337,638.72,148.039Z",
    transform: "translate(0)",
    style: {
      fill: "#f07378"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.426,288.605a40.756,40.756,0,1,1,40.755-40.756A40.756,40.756,0,0,1,643.426,288.605Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.426,288.605a40.756,40.756,0,1,1,40.755-40.756A40.756,40.756,0,0,1,643.426,288.605Z",
    transform: "translate(0)",
    style: {
      fill: "none",
      stroke: "#363a5a",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.481,249.681c0-57.8-46.914-104.344-103.761-101.642-50.9,2.42-94.292,45.782-94.292,98.124,0,75.717,99,134.1,99,134.1S742.481,321.88,742.481,249.681Z",
    transform: "translate(0)",
    style: {
      fill: "none",
      stroke: "#363a5a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.925,937.592a2.267,2.267,0,0,0,2.421-2.334,2.071,2.071,0,0,0-2.29-2.2,2.2,2.2,0,0,0-2.421,2.139v.064A2.277,2.277,0,0,0,420.925,937.592Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.412,941.87c-.13-.778,1.178-.908,1.047-1.556-.131-.907-.916-.907-1.439-.843-2.945.325-3.534,1.3-3.795,3.176a4.023,4.023,0,0,0,1.308,2.917,21.625,21.625,0,0,1-.523,4.407.925.925,0,0,0-.524.583,56.18,56.18,0,0,1-1.766,6.287,3.239,3.239,0,0,0-.655,1.232v.324c-.654,1.231-1.374,2.138-2.224,2.138-.393,0-.524-1.037-.524-2.4,0-2.4,1.243-9.073,1.243-10.5,0-1.88.328-3.5.328-5.056,0-.648-.459-.842-1.047-.842-.458,0-.72.324-1.178.324-1.9,0-2.16,1.037-2.16,2.592,0,.649,0,9.852-.13,11.018-.131,1.945-1.244,4.343-3.337,4.343-1.9,0-2.814-2.593-2.814-5.38a31.409,31.409,0,0,1,.785-6.8c.2-.648,1.047-3.629,1.047-4.018,0-.713-.065-.907-.851-.907-3.01.064-3.6.324-4.056,1.944a36.319,36.319,0,0,0-.982,8.037v.842c-.72,2.2-1.5,4.667-3.533,4.8-1.375.065-1.833-3.37-1.833-6.935,0-7.064,2.029-13.934,2.291-21,.065-.648-.393-1.1-1.178-1.1a9.691,9.691,0,0,1-1.832.065c-.785,0-1.113.324-1.178,1.1-.654,7.065-2.094,15.685-2.094,22.555v.129c-.72,2.269-1.5,5.185-3.664,5.315-1.374.065-1.832-3.37-1.832-6.935,0-7.065,2.028-13.935,2.29-21,.065-.648-.393-1.1-1.178-1.1-1.047,0-1.374-.065-1.9-.065-.785,0-1.112.324-1.177,1.1-.655,7.065-2.094,15.685-2.094,22.555v.129c-.72,2.269-1.5,5.185-3.664,5.315-1.375.065-1.833-3.37-1.833-6.935,0-7.065,2.029-13.935,2.291-21,.065-.648-.393-1.1-1.178-1.1-1.113,0-1.44-.065-1.963-.065-.785,0-1.113.324-1.178,1.1-.654,7.065-2.094,15.685-2.094,22.555v1.037c-.654,2.268-1.636,4.731-2.879,4.731-.589-.065-1.047-.907-1.047-2.852,0-3.564.327-8.49.654-12.249.066-.454-.13-.908-.654-.908-.458-.064-1.9-.194-2.421-.194-.785,0-1.112.454-1.112,1.3v1.3c.065,4.343-.393,7.778-.393,11.861,0,2.917,1.57,4.926,3.533,4.926,2.094,0,3.73-1.75,4.843-3.824.588,2.2,1.7,4.148,3.926,4.148,2.093,0,4.122-2.269,5.5-4.8.523,2.463,1.636,4.8,4.057,4.8,2.094,0,4.122-2.269,5.5-4.8.524,2.463,1.636,4.8,4.057,4.8,2.029,0,4.057-2.2,5.431-4.6.72,2.917,2.356,5.12,5.431,5.12,2.552,0,3.272-1.037,4.908-3.37.523,1.3.719,3.759,2.224,3.759,2.094,0,3.861-2.4,5.039-5.12a8.291,8.291,0,0,0,6.543,3.629c3.533,0,6.543-2.527,6.282-6.351C484.722,950.36,477,944.786,476.412,941.87Zm.916,17.434c-1.046,0-2.682-.648-2.748-2.009-.065-.778,1.767-1.167,2.421-1.556.524-.324.655-.583.655-.777-.066-.454-.72-.778-1.44-.778a4.5,4.5,0,0,0-2.421.842c.2-.907,1.57-5.573,1.9-7.842a14.918,14.918,0,0,1,5.169,9.333C481.058,959.045,478.179,959.3,477.328,959.3Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.957,937.592a2.267,2.267,0,0,0,2.421-2.334,2.071,2.071,0,0,0-2.29-2.2,2.2,2.2,0,0,0-2.421,2.139v.064A2.277,2.277,0,0,0,535.957,937.592Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.777,963.128c-1.178-.778-2.028-2.009-1.832-7.065.131-3.24.785-7.712.785-10.888,0-1.426-.654-3.046-2.486-3.046-2.29,0-5.628,4.666-6.675,6.74.131-1.231.524-4.861.589-6.092s.066-1.3-2.094-1.3c-1.439,0-1.569.259-1.569.777,0,2.982-.263,6.417-.524,9.852-.786,1.685-1.833,3.37-3.338,3.37a3.006,3.006,0,0,1-1.308-.324,9.938,9.938,0,0,0,1.113-4.342,3.117,3.117,0,0,0-3.141-3.241,3.709,3.709,0,0,0-3.861,4.018c0,1.815,1.9,3.889,3.337,4.861a4.97,4.97,0,0,1-4.515,2.722c-2.813,0-3.8-5.12-3.8-7,0-3.63,1.309-7.713,5.627-7.713,2.945,0,2.945,1.944,4.188,1.944.131,0,.524-.194.524-.388,0-2.139-3.4-3.889-5.17-3.889-6.02,0-10.207,4.731-10.207,10.629a11.3,11.3,0,0,0,.589,3.565c-.589,1.49-1.309,2.657-2.225,2.657-.589,0-1.047-.843-1.047-2.787,0-3.565.327-8.49.654-12.249.066-.454-.131-.908-.654-.908-.458-.065-1.9-.194-2.421-.194-.785,0-1.113.453-1.113,1.3v1.3c0,2.269-.13,4.213-.2,6.157a1.432,1.432,0,0,0-.2.324c-.72,1.945-1.636,7.324-3.8,7.324-.655,0-2.029-.907-2.029-3.435,0-4.083,1.374-12.249,1.571-13.675,2.093-.454,3.926-.324,6.412-1.037,1.113-.324.458-1.62-.785-1.491a34.906,34.906,0,0,1-5.431,0c.065-2.139.589-3.5.589-5.7v-.2c0-.583-.262-1.037-.851-1.037-1.178,0-3.01.389-3.01,2.009,0,1.686-.326,3.176-.262,4.861-1.177.065-2.224-.259-3.4-.259-.85,0-1.047,1.556-1.047,2.139,0,.648.066,1.1.458,1.1a30.272,30.272,0,0,0,3.73-.324c-.327,4.277-.85,6.675-1.178,9.657,0,.194-.066.453-.066.713-.719,2.268-2.093,5.768-3.205,5.768A1.464,1.464,0,0,1,519.4,957.1,42.575,42.575,0,0,1,520.58,946.8a11.062,11.062,0,0,0,.654-2.527c0-.843-1.374-1.3-2.093-1.3-1.178,0-1.113.648-1.571,1.685-.851-.648-1.047-1.814-3.337-1.814-4.188,0-6.74,6.74-6.74,10.953,0,.713-.065,1.1-.065,1.491,0,2.4-1.374,5.379-2.814,5.379-1.243,0-1.636-3.37-1.636-4.8a31.6,31.6,0,0,1,1.7-8.426,6.148,6.148,0,0,0,.916-2.268c0-.907-1.047-2.4-2.094-2.4-1.178,0-1.9.648-3.141.648-1.963,0-3.272-1.231-4.384-1.231a1.026,1.026,0,0,0-1.113,1.1c0,1.75,1.9,1.426,1.44,3.63-.458,2.074-1.832,7.713-2.617,9.851a.48.48,0,0,0-.066.324,1.892,1.892,0,0,0,.132.649c-.459.777-.982,1.3-1.637,1.3s-2.028-.908-2.028-3.435c0-4.083,1.374-12.25,1.571-13.676,2.094-.453,3.925-.324,6.412-1.037,1.112-.324.458-1.62-.786-1.49a35.035,35.035,0,0,1-5.431,0c.066-2.139.589-3.5.589-5.7,0-.583-.261-1.037-.85-1.037-1.178,0-3.01.389-3.01,2.009,0,1.686-.327,3.176-.262,4.861-1.177.065-2.224-.259-3.4-.259-.851,0-1.047,1.556-1.047,2.139,0,.648.065,1.1.458,1.1a30.272,30.272,0,0,0,3.73-.324c-.327,4.277-.851,6.675-1.178,9.657a53.122,53.122,0,0,0-.458,5.573c0,2.787,2.42,5.056,4.449,5.056,3.6,0,6.543-7.259,6.543-10.24v-.389c.393-1.75.655-3.5.982-4.991.065-.194.262-.778.785-.778,1.178,0,1.309.843,1.309,1.75,0,2.4-.851,6.676-.851,9.2,0,2.462.654,5.509,3.534,5.509a6.357,6.357,0,0,0,5.5-3.63c.785,1.88,2.094,3.37,3.926,3.37,1.767,0,3.272-1.3,4.319-2.527.262.648.654,2.4,2.552,2.4,1.766,0,3.141-1.491,4.188-3.371a4.919,4.919,0,0,0,4.252,3.76c2.029,0,3.926-2.4,5.1-4.991.131,2.722,1.636,4.537,3.534,4.537,1.963,0,3.6-1.556,4.711-3.5a6.643,6.643,0,0,0,5.758,3.37c3.6,0,5.758-2.333,7.655-5.12a9.921,9.921,0,0,0,1.833.324,4.887,4.887,0,0,0,3.468-2.009c-.131,2.074-.262,4.083-.262,5.9,0,.648.131.907.589,1.037a5.742,5.742,0,0,0,1.832.065c.654,0,.785.065.916-.778.065-.583.458-7.518.458-8.037,0-1.426,3.468-7.453,5.169-7.453.328,0,.589.583.589.972,0,3.111-.981,8.166-.981,11.407,0,3.435,1.7,4.6,2.421,4.991a6.445,6.445,0,0,0,2.813.713C573.777,963.776,574.235,963.387,573.777,963.128Zm-57.45-6.611c-.066.907-1.7,3.241-2.945,3.241-1.374,0-1.963-3.889-1.9-6.481.065-3.047,1.57-8.491,3.01-8.491,1.9,0,2.159,4.537,2.159,5.963C516.654,952.369,516.458,954.9,516.327,956.517Zm37.559-2.139a4.186,4.186,0,0,1-1.374-3.111c0-.583.2-1.879,1.047-1.879.785,0,1.046,1.426,1.046,2.009A11.079,11.079,0,0,1,553.886,954.378Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.826,955.48c-.327-5.12-8.114-10.694-8.637-13.611-.13-.777,1.178-.907,1.047-1.555-.13-.907-.916-.907-1.44-.843-2.944.324-3.533,1.3-3.794,3.176a4.027,4.027,0,0,0,1.308,2.917c.066,2.268-1.177,8.555-2.617,11.018a5.056,5.056,0,0,0-.851,1.491c-.131.777.458,1.166.982.648.458-.389.392-.648.85-.973,1.047,2.4,4.319,4.084,6.806,4.084C586.079,961.832,589.023,959.3,588.826,955.48Zm-7.72,3.824c-1.047,0-2.683-.648-2.749-2.009-.065-.778,1.767-1.167,2.421-1.556.523-.324.655-.583.655-.777-.066-.454-.721-.778-1.44-.778a4.5,4.5,0,0,0-2.421.842c.2-.907,1.571-5.574,1.9-7.842a14.907,14.907,0,0,1,5.168,9.333C584.835,959.045,581.956,959.3,581.106,959.3Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,959.2c0,2.5-1.2,3.7-2.6,3.7a1.928,1.928,0,0,1-2.1-1.4,2.2,2.2,0,0,1-1.8.8,2.808,2.808,0,0,1,0-5.6,2.175,2.175,0,0,1,1.6.7v-.5h1.6v3.9c0,.8.3,1.4,1,1.4.9,0,1.7-.9,1.7-3a5.233,5.233,0,0,0-5.4-5.3,5.552,5.552,0,0,0-5.6,5.7,5.624,5.624,0,0,0,5.9,5.7,11.935,11.935,0,0,0,2.9-.4v.6a8.119,8.119,0,0,1-2.9.4,6.2,6.2,0,1,1-.3-12.4A5.593,5.593,0,0,1,63.2,959.2Zm-4.9.3a1.347,1.347,0,0,0-1.3-1.4,1.238,1.238,0,0,0-1.3,1.4,1.261,1.261,0,0,0,1.3,1.3C57.8,960.9,58.3,960.3,58.3,959.5Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4,955.1v2a2.244,2.244,0,0,0-2.6,2.4v4.3H64.9v-8.6h1.9v1.4A2.632,2.632,0,0,1,69.4,955.1Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6,962.3a2.641,2.641,0,0,0,2.2-1.1l1.5.9a4.346,4.346,0,0,1-3.8,1.9,4.414,4.414,0,0,1-4.7-4.5,4.36,4.36,0,0,1,4.5-4.5,4.313,4.313,0,0,1,4.3,4.5,2.2,2.2,0,0,1-.1.8H71.7A2.832,2.832,0,0,0,74.6,962.3Zm2.3-3.5a2.375,2.375,0,0,0-2.5-2.1,2.506,2.506,0,0,0-2.6,2.1Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9,955.2v8.6H87v-1.2a3.692,3.692,0,0,1-3,1.5,4.443,4.443,0,0,1-4.3-4.5,4.317,4.317,0,0,1,4.3-4.5,3.613,3.613,0,0,1,3,1.4v-1.2h1.9Zm-1.8,4.3a2.7,2.7,0,1,0-2.7,2.7A2.571,2.571,0,0,0,87.1,959.5Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,951.3H93v12.5H91.1Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,955.2l-3.3,8.6H97.5l-3.3-8.6h2l2.4,6.5,2.4-6.5Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,955.2h1.9v8.9c0,2.4-1.2,3.5-3.5,3.3v-1.8c1.1.1,1.7-.3,1.7-1.5v-8.9Zm-.2-2.4a1.2,1.2,0,0,1,2.4,0,1.2,1.2,0,1,1-2.4,0Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,955.2l-3.3,8.8c-.8,2.2-2.2,3.3-4.2,3.2v-1.7a2.076,2.076,0,0,0,2.3-1.7l.1-.2-3.6-8.4h2l2.6,6.2,2.2-6.2Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,938.7a3.633,3.633,0,0,1-3.6,3.8h-3v-7.6h3A3.633,3.633,0,0,1,58.9,938.7Zm-1,0a2.722,2.722,0,0,0-2.6-2.9h-2v5.7h2A2.577,2.577,0,0,0,57.9,938.7Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,941.6v1H62.4V935h4.5v1H63.4v2.3h3.2v.9H63.4v2.4Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,940.8l.9-.5a1.987,1.987,0,0,0,2,1.4c1.1,0,1.6-.5,1.6-1.2,0-.8-.7-1-1.8-1.4-1.2-.4-2.4-.8-2.4-2.2a2.208,2.208,0,0,1,2.4-2.2,2.664,2.664,0,0,1,2.6,1.7l-.8.5a1.743,1.743,0,0,0-1.7-1.2c-.8,0-1.4.4-1.4,1.1s.5,1,1.6,1.3c1.3.4,2.6.8,2.6,2.3a2.333,2.333,0,0,1-2.6,2.2A2.847,2.847,0,0,1,70,940.8Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,934.9v7.6H79v-7.6Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3,939.2a3.47,3.47,0,0,1-3.7,3.5,3.888,3.888,0,0,1-4-4,3.974,3.974,0,0,1,7.3-2.2l-.9.5a2.775,2.775,0,0,0-2.4-1.4,3,3,0,0,0,0,6,2.5,2.5,0,0,0,2.7-2H87.5v-.9h3.8Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,934.9v7.6h-.8l-3.9-5.7v5.7h-1v-7.6h.8l3.9,5.7v-5.7Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1,941.6v1h-4.6V935H109v1h-3.5v2.3h3.2v.9h-3.2v2.4Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.2,938.7a3.633,3.633,0,0,1-3.6,3.8h-3v-7.6h3A3.7,3.7,0,0,1,119.2,938.7Zm-1,0a2.722,2.722,0,0,0-2.6-2.9h-2v5.7h2A2.577,2.577,0,0,0,118.2,938.7Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2,940.4a2.22,2.22,0,0,1-2.2,2.2h-3.3V935h3a2.051,2.051,0,0,1,2.1,2.1,1.943,1.943,0,0,1-.8,1.6A1.658,1.658,0,0,1,133.2,940.4Zm-4.5-4.6v2.3h2a1.135,1.135,0,0,0,1.1-1.2,1.2,1.2,0,0,0-1.1-1.2h-2Zm3.5,4.5a1.155,1.155,0,0,0-1.2-1.2h-2.3v2.5H131A1.24,1.24,0,0,0,132.2,940.3Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6,2.1-3.6h1.1Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.957,934.972v7.7h-.825l-3.96-5.754v5.754h-1.024v-7.7h.826l3.96,5.743v-5.743Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.405,941.705v.968h-4.6v-7.7h4.544v.967H215.83v2.367h3.245v.957H215.83v2.442Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.286,934.972h1.078l1.76,6.337,1.87-6.337h1.034l1.87,6.337,1.761-6.337h1.078l-2.211,7.7h-1.188l-1.826-6.15-1.826,6.15H224.5Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.22,934.972v7.7h-1.013v-6.6l-1.639.484-.253-.88,2.025-.7Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.772,938.822c0-2.376,1.068-3.993,2.971-3.993s2.97,1.617,2.97,3.993-1.056,3.993-2.97,3.993S246.772,941.2,246.772,938.822Zm4.929,0c0-1.914-.715-3-1.958-3s-1.947,1.089-1.947,3,.7,2.992,1.947,2.992S251.7,940.736,251.7,938.822Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.545,938.965h.011l-2.487,3.708h-1.155l1.826-2.7c-.12.01-.241.021-.374.021a2.586,2.586,0,1,1,2.652-2.585A2.593,2.593,0,0,1,260.545,938.965Zm-2.179.066a1.612,1.612,0,1,0-1.638-1.617A1.541,1.541,0,0,0,258.366,939.031Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.81,963.624h-2.434v-8.063l-3.5,5.772h-.284l-3.5-5.755v8.046h-2.451V951.191h2.522l3.57,5.879,3.552-5.879h2.523Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.046,954.743v8.881h-2.291v-1.048a3.536,3.536,0,0,1-2.895,1.3,4.705,4.705,0,0,1,0-9.378,3.536,3.536,0,0,1,2.895,1.3v-1.048Zm-2.291,4.441a2.46,2.46,0,1,0-2.469,2.5A2.387,2.387,0,0,0,226.755,959.184Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.622,959.184a4.5,4.5,0,0,1-4.333,4.689,3.449,3.449,0,0,1-2.878-1.3v4.6H231.12V954.743h2.291v1.048a3.454,3.454,0,0,1,2.878-1.3A4.494,4.494,0,0,1,240.622,959.184Zm-2.291,0a2.46,2.46,0,1,0-2.469,2.5A2.387,2.387,0,0,0,238.331,959.184Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.973,961.279v2.345h-7.194V951.191h2.451v10.088Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.608,959.184a4.7,4.7,0,1,1,4.69,4.689A4.64,4.64,0,0,1,254.608,959.184Zm7.105,0a2.407,2.407,0,1,0-2.415,2.451A2.362,2.362,0,0,0,261.713,959.184Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.154,959.184a4.587,4.587,0,0,1,4.69-4.689,4.469,4.469,0,0,1,3.978,2.291l-1.971,1.154a2.2,2.2,0,0,0-2.026-1.19,2.425,2.425,0,0,0,0,4.85,2.191,2.191,0,0,0,2.043-1.173l1.989,1.136a4.672,4.672,0,0,1-8.7-2.379Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.96,954.743v8.881h-2.292v-1.048a3.536,3.536,0,0,1-2.895,1.3,4.705,4.705,0,0,1,0-9.378,3.536,3.536,0,0,1,2.895,1.3v-1.048Zm-2.292,4.441a2.46,2.46,0,1,0-2.469,2.5A2.387,2.387,0,0,0,281.668,959.184Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.106,956.945v3.7c0,.959.693.976,2.007.905v2.078c-3.215.355-4.3-.586-4.3-2.983v-3.7H285.27v-2.2h1.544v-1.794l2.292-.692v2.486h2.007v2.2Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.46,952.274a1.412,1.412,0,1,1,1.4,1.4A1.419,1.419,0,0,1,292.46,952.274Zm.267,2.469h2.291v8.881h-2.291Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.65,959.184a4.7,4.7,0,1,1,4.69,4.689A4.64,4.64,0,0,1,296.65,959.184Zm7.105,0a2.407,2.407,0,1,0-2.415,2.451A2.362,2.362,0,0,0,303.755,959.184Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.953,958.171v5.453h-2.292v-5.169a1.652,1.652,0,0,0-1.758-1.829c-1.119,0-1.954.657-1.954,2.2v4.8h-2.291v-8.881h2.291v1A3.018,3.018,0,0,1,312.6,954.5C314.479,954.5,315.953,955.809,315.953,958.171Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.133,938.45a3.648,3.648,0,0,1-3.617,3.813h-2.973v-7.626h2.973A3.648,3.648,0,0,1,848.133,938.45Zm-.969,0a2.669,2.669,0,0,0-2.648-2.855h-1.961V941.3h1.961A2.669,2.669,0,0,0,847.164,938.45Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.254,938.45a3.949,3.949,0,1,1,3.943,3.955A3.917,3.917,0,0,1,851.254,938.45Zm6.887,0a2.943,2.943,0,1,0-2.944,2.964A2.911,2.911,0,0,0,858.141,938.45Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.783,934.637h1.069l1.742,6.276,1.853-6.276h1.024l1.851,6.276,1.744-6.276h1.067l-2.19,7.626h-1.175l-1.809-6.09-1.809,6.09h-1.177Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.27,934.637v7.626h-.819l-3.922-5.7v5.7h-1.011v-7.626h.816l3.922,5.687v-5.687Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.5,941.3v.959h-4.3v-7.626h1.014V941.3Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.877,938.45a3.949,3.949,0,1,1,3.943,3.955A3.917,3.917,0,0,1,891.877,938.45Zm6.887,0a2.943,2.943,0,1,0-2.944,2.964A2.911,2.911,0,0,0,898.764,938.45Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.418,940.552h-3.432l-.621,1.711h-1.078l2.844-7.626h1.142l2.844,7.626h-1.078Zm-.348-.947-1.373-3.759-1.361,3.759Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.906,938.45a3.647,3.647,0,0,1-3.617,3.813h-2.975v-7.626h2.975A3.647,3.647,0,0,1,918.906,938.45Zm-.97,0a2.67,2.67,0,0,0-2.647-2.855h-1.961V941.3h1.961A2.669,2.669,0,0,0,917.936,938.45Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.457,935.6v2.474h3.236v.959h-3.236v3.235h-1.014v-7.626h4.391v.958Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.168,939.343h-1.8v2.92h-1.012v-7.626h3.049a2.353,2.353,0,0,1,.8,4.575l1.8,3.051h-1.121Zm-1.8-.915h2.037a1.423,1.423,0,0,0,0-2.843h-2.037Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.869,938.45a3.95,3.95,0,1,1,3.943,3.955A3.918,3.918,0,0,1,943.869,938.45Zm6.887,0a2.943,2.943,0,1,0-2.944,2.964A2.911,2.911,0,0,0,950.756,938.45Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.418,942.263h-1V936.3l-2.5,4.151h-.131l-2.494-4.14v5.948h-1.014v-7.626h1.145l2.429,4.031,2.418-4.031h1.145Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.318,952.65a1.221,1.221,0,1,1,1.221,1.222A1.224,1.224,0,0,1,841.318,952.65Zm.266,2.549H843.5v8.85h-1.911Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.709,951.128h1.912v12.921h-1.912Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.834,951.128h1.912v12.921h-1.912Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.96,951.128h1.911v12.921H853.96Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.963,955.2v8.85h-1.912v-1.132a3.048,3.048,0,0,1-2.744,1.363,3.305,3.305,0,0,1-3.4-3.647V955.2h1.912v5.24a1.845,1.845,0,0,0,1.983,2.053c1.257,0,2.248-.743,2.248-2.549V955.2Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.621,961.553c0,1.771-1.539,2.727-3.451,2.727a3.694,3.694,0,0,1-3.611-2.071l1.646-.956a1.945,1.945,0,0,0,1.965,1.274c.85,0,1.5-.283,1.5-.991,0-1.575-4.761-.691-4.761-3.859,0-1.664,1.434-2.708,3.238-2.708a3.566,3.566,0,0,1,3.276,1.841l-1.612.9a1.723,1.723,0,0,0-1.664-1.008c-.689,0-1.292.3-1.292.938C869.86,959.253,874.621,958.279,874.621,961.553Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.7,957.041v4.248c0,1.132.744,1.114,2.2,1.044v1.716c-2.938.355-4.106-.46-4.106-2.76v-4.248h-1.629V955.2h1.629v-1.911l1.91-.567V955.2h2.2v1.842Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.354,955.04v2.071a2.337,2.337,0,0,0-2.725,2.478v4.46h-1.912V955.2h1.912v1.487A2.782,2.782,0,0,1,887.354,955.04Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.286,955.2v8.85h-1.911v-1.274a3.639,3.639,0,0,1-3.1,1.5,4.662,4.662,0,0,1,0-9.311,3.672,3.672,0,0,1,3.1,1.487V955.2Zm-1.911,4.426a2.8,2.8,0,1,0-2.8,2.832A2.735,2.735,0,0,0,895.375,959.625Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.264,957.041v4.248c0,1.132.744,1.114,2.195,1.044v1.716c-2.938.355-4.1-.46-4.1-2.76v-4.248h-1.629V955.2h1.629v-1.911l1.91-.567V955.2h2.195v1.842Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.931,952.65a1.221,1.221,0,0,1,2.442,0,1.221,1.221,0,1,1-2.442,0Zm.265,2.549h1.911v8.85H906.2Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.826,959.625a4.673,4.673,0,1,1,4.674,4.655A4.621,4.621,0,0,1,909.826,959.625Zm7.435,0a2.762,2.762,0,1,0-2.761,2.8A2.718,2.718,0,0,0,917.261,959.625Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.965,958.616v5.433h-1.912V958.81a1.845,1.845,0,0,0-1.983-2.053c-1.257,0-2.248.744-2.248,2.549v4.743H920.91V955.2h1.912v1.133a3.047,3.047,0,0,1,2.744-1.363A3.3,3.3,0,0,1,928.965,958.616Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.5,961.553c0,1.771-1.541,2.727-3.451,2.727a3.692,3.692,0,0,1-3.611-2.071l1.646-.956a1.943,1.943,0,0,0,1.965,1.274c.849,0,1.5-.283,1.5-.991,0-1.575-4.762-.691-4.762-3.859,0-1.664,1.434-2.708,3.239-2.708a3.563,3.563,0,0,1,3.275,1.841l-1.611.9a1.725,1.725,0,0,0-1.664-1.008c-.69,0-1.292.3-1.292.938C932.738,959.253,937.5,958.279,937.5,961.553Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.83,962.934a1.328,1.328,0,0,1,2.656,0,1.328,1.328,0,0,1-2.656,0Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.319,959.625a4.567,4.567,0,0,1,4.673-4.656,4.373,4.373,0,0,1,3.947,2.284l-1.646.956a2.473,2.473,0,0,0-2.318-1.364,2.779,2.779,0,0,0,0,5.558,2.6,2.6,0,0,0,2.353-1.362l1.647.937a4.451,4.451,0,0,1-3.983,2.3A4.577,4.577,0,0,1,942.319,959.625Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.722,959.625a4.673,4.673,0,1,1,4.673,4.655A4.62,4.62,0,0,1,951.722,959.625Zm7.434,0a2.762,2.762,0,1,0-2.761,2.8A2.718,2.718,0,0,0,959.156,959.625Z",
    transform: "translate(0)",
    style: {
      fill: "#ee4637"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.ba182b427e373bea1476ddc7e0e0bb35.svg";
export { ForwardRef as ReactComponent };